
import { fetchWrapper } from 'app/_helpers/fetch-wrapper';
const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const WMSInventoryURL = process.env.REACT_APP_API_WMSINVENTORY_URL;
const baseUrl = `${WMSInbondURL}inventory`;
const baseUrlInventory = `${WMSInventoryURL}inventory`;

export const InventoryService = {
    getAll,
    getById,
    create,
    update,
    GetArticleLegder,
    GetSKULegder,
    ClientStockReport,
    InboundReportByclientId,
    OutboundReportByclientId,
    InboundReportByAdviceId,
    delete: _delete
};

async function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}
function GetArticleLegder(id) {
    return fetchWrapper.get(`${baseUrl}/sku-id?id=${id}`);
}
function GetSKULegder(id) {
    return fetchWrapper.get(`${baseUrlInventory}/skuLedger/${id}`);
}
function ClientStockReport(id) {
    return fetchWrapper.get(`${baseUrlInventory}/stockReportByclientId/${id}`);
}
function InboundReportByclientId(id) {
    return fetchWrapper.get(`${baseUrlInventory}/inWardReportByclientId/${id}`);
}
function OutboundReportByclientId(id) {
    return fetchWrapper.get(`${baseUrlInventory}/outward-report-client-id/${id}`);
}

function InboundReportByAdviceId(id) {

    return fetchWrapper.get(`${baseUrlInventory}/inWardReportByAdviceId/${id}`);
}


function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {

    return fetchWrapper.put(`${baseUrl}/${id}`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}
